export default __webpack_public_path__ + "static/media/banner.00beeb87.jpg";